import React, { useState, useEffect } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import PopupState, { bindToggle, bindPopover } from "material-ui-popup-state";
import {
  ModeEdit,
  CheckCircleOutlineOutlined,
  CancelOutlined,
} from "@mui/icons-material";
import moment from "moment";
import KeyResults from "../KeyResults/KeyResults";
import { loadStatus, loadUsers } from "../../../../redux/actions/lookups.action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { axiosFetch } from "../../../../utils/AxiosFetch";
import { AddNewCommentsPopup } from "../AddNewCommentsPopup/Index";
import { Comments } from "../Comments/Index";
import { AuditLog } from "../AuditLog/Index";
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import {
  Grid,
  Paper,
  Box,
  Button,
  Typography,
  Tabs,
  Tab,
  Badge,
  Popover,
  IconButton,
  TextField,
  TextareaAutosize,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  DialogContent,
  Alert

} from "@mui/material";
import AddNewOkr from "../AddNewOkr";
import { update } from "../../../../redux/actions/updateData.action";
import "./ViewOKR.css";
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import { CustomizedSnackbar } from "../../../../shared";
import { StencilList } from "react-placemoulder";
import dummyData from './ContentLoaderData.json';
import InfiniteScroll from "react-infinite-scroller";
import ViewOKRDummyData from './ViewOkrContentLoaderData.json';
import Link from "@mui/material/Link";
import DatePicker from "react-datepicker";
// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import FileUpload from "./FileUpload";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { Close, TrafficOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

let keyResults = [];
const ViewOKR = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [commentId, setCommentId] = useState('');
  let [isRestrictOwnerUpdate, setIsRestrictOwnerUpdate] = useState(true);
  let [isRestrictParticipantUpdate, setIsRestrictParticipantUpdate] = useState(true);
  let statusList = useSelector((state) => state.loadStatus_Reducer.statusList);
  let usersList = useSelector((state) => state.loadUsers_Reducer.usersList);


  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(1);
  const [isPrivate, setIsPrivate] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [keyResultsList, setKeyResultsList] = useState(dummyData);
  const [isLoading, setIsLoading] = useState(false);
  const [title_toEditErrMsg, setTitle_toEditErrMsg] = useState(false);
  const [description_toEditErrMsg, setDesciption_toEditErrMsg] = useState(false);
  const [isLoadingKeyResult, setIsLoadingKeyResult] = useState(false);
  const [dueDate_toEditErrMsg, setDueDate_toEditErrMsg] = useState(false);
  const [owner_toEditErrMsg, setOwner_toEditErrMsg] = useState(false);
  const [participants_toEditErrMsg, setParticipants_toEditErrMsg] = useState(false);
  const [isErrorStatus, setIsErrorStatus] = useState(false);


  var userDetails =
    localStorage.getItem("argus_user") !== null
      ? localStorage.getItem("argus_user")
      : null;
  var userType =
    userDetails !== null && JSON.parse(userDetails).usertype !== null
      ? JSON.parse(userDetails).usertype
      : "";
  var userid =
    userDetails !== null && JSON.parse(userDetails).userid !== null
      ? JSON.parse(userDetails).userid
      : "";
  const [description_toEdit, setDescription_toEdit] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [title_toEdit, setTitle_toEdit] = useState("");
  const [totalPages, setTotalPages] = useState("");
  const [totalRecords, setTotalRecords] = useState("");
  const [isContentAvailable, setIsContentAvailable] = useState(false);
  const [krUserList, setKRUserList] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [dueDate_toEdit, setDueDate_toEdit] = useState(new Date());
  const [owner_toEdit, setOwner_toEdit] = useState([]);
  const [participants_toEdit, setParticipants_toEdit] = useState([]);

  const [basic_OkrDetails, setBasic_OkrDetails] = useState(null);
  const [createdby, setCreatedBy] = useState("");
  const [pageData, setPageData] = useState(null);
  const [isOpen_CommentsPopup, setIsOpen_CommentsPopup] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [comments, setComments] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);
  const [isAssignKR, setIsAssignKR] = React.useState(false);
  const [selectedOkrId, setSelectedOkrId] = React.useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [isErrorOwner, setIsErrorOwner] = useState(false);
  const [isErrorParticipant, setIsErorParticipant] = useState(false);




  const handleChange = (event, newValue) => {

    setTabValue(newValue);
  };
  const publishOKR = () => {
    var req = {
      "itemId": basic_OkrDetails !== null ? basic_OkrDetails.id : null,
      "fieldName": "isPrivate",
      "tableName": "OkrObjects",
      "value": false.toString(),
      "typeId": 2
    }

    dispatch(update(req));
    dispatch(SnackbarActions(true, "success", "Now, Everyone can view this OKR"));
    loadBasicOKRDetails();

  }
  const toggleDraft = () => {

    setIsPublished(!isPublished);
    var req = {
      "itemId": basic_OkrDetails !== null ? basic_OkrDetails.id : null,
      "fieldName": "isPublished",
      "value": (!isPublished).toString(),
      "typeId": 2,
      "tableName": "OkrObjects"
    }

    dispatch(update(req));
    isPublished ? dispatch(SnackbarActions(true, "success", "Saved As Draft")) : dispatch(SnackbarActions(true, "success", "Removed from Draft"));
    loadBasicOKRDetails();
  }

  const handleTitleUpdate = () => {

    if (title_toEdit === "") {
      setTitle_toEditErrMsg(true);
      return false;
    }

    var req = {
      "itemId": id,
      "tableName": pageData.table,
      "fieldName": "title",
      "typeId": 2,
      "value": title_toEdit
    }
    dispatch(update(req));
    dispatch(SnackbarActions(true, "success", "Updated Successfully"));
    var close = document.getElementById("closebtn");
    close.click();
    loadBasicOKRDetails();
  };

  const handleDescriptionUpdate = () => {

    if (description_toEdit === "") {
      setDesciption_toEditErrMsg(true);
      return false;
    }
    var req = {
      "itemId": id,
      "tableName": pageData.table,
      "fieldName": "description",
      "typeId": 2,
      "value": description_toEdit
    }
    dispatch(update(req));
    var close = document.getElementById("closebtn");
    close.click();
    loadBasicOKRDetails();
  };

  const handleChangeDueDate = (date) => {

    setDueDate_toEdit(date);
    setDueDate_toEditErrMsg(false);
  }
  const handleChangeStatus = (obj) => {

    if (parseInt(obj.value) === 1) {
      setIsErrorStatus(true);

    }
    else {
      setIsErrorStatus(false);
      setSelectedStatus(obj);
    }

    // setSelectedStatusErrMsg(false);
  }

  const toggleCommentsPopup = (param) => {


    if (param !== undefined && typeof (param) !== 'number') {
      setIsOpen_CommentsPopup(false);
      setCommentId("");
    }
    else {
      setIsOpen_CommentsPopup(true);
      setCommentId(param !== undefined && typeof (param) === 'number' ? param : "");
      // krId = param !== undefined && typeof (param) === 'number' ? param : null
    }

  }

  const handleStatusUpdate = () => {

    if (selectedStatus === null) {
      // setSelectedStatusErrMsg(true);
      return false;
    }
    var req = {
      "itemId": id,
      "tableName": pageData.table,
      "fieldName": "statusId",
      "typeId": 2,
      "value": selectedStatus.value
    }
    dispatch(update(req));
    dispatch(SnackbarActions(true, "success", "Updated Successfully"));
    var close = document.getElementById("closebtn");
    close.click();
    loadBasicOKRDetails();

  };

  const handleChangeOwner_toEdit = (arr) => {

    if (arr.length !== 0 && (basic_OkrDetails.users.participants.filter(owner => owner.id === parseInt(arr[arr.length - 1].value)).length !== 0 || basic_OkrDetails.users.participants.filter(participants => arr.some(user => user.value == participants.id)).length)) {
      setIsErrorOwner(true);
      setIsRestrictOwnerUpdate(true);
      return false;
    }
    else {
      setIsErrorOwner(false);
      setIsRestrictOwnerUpdate(false);
      setOwner_toEdit(arr);
      setOwner_toEditErrMsg(false);
    }


  }

  const handleDueDateUpdate = () => {

    if (dueDate_toEdit === "") {
      setDueDate_toEditErrMsg(true);
      return false;
    }
    var req = {
      "itemId": id,
      "tableName": pageData.table,
      "fieldName": "dueDate",
      "typeId": 2,
      "value": moment(dueDate_toEdit).format('YYYY-MM-DD')
    }
    dispatch(update(req));

    dispatch(SnackbarActions(true, "success", "Updated Successfully"))
    var close = document.getElementById("closebtn");
    close.click();
    loadBasicOKRDetails();

  };

  const handleOwnerUpdate = () => {
    setIsRestrictOwnerUpdate(true);
    let selectedOwnersId;
    if (owner_toEdit.length === 0) {
      setOwner_toEditErrMsg(true);
      return false;
    }
    if (owner_toEdit.length !== 0) {
      selectedOwnersId = owner_toEdit.map(owner => owner.value).toString();
    }

    var close = document.getElementById("closebtn");
    close.click();

    axiosFetch({
      method: "post",
      url: "/okrs/assign",
      requestConfig: {
        OkrIds: id,
        assignmentTypeId: 1,
        assignedUserId: owner_toEdit.length !== 0 ? selectedOwnersId : null
      }
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === 'success') {
            dispatch(SnackbarActions(true, "success", "Updated Successfully"));
            loadBasicOKRDetails();
          }
        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })

      .catch(err => console.error(err));
  };

  const handleChangeParticipants = (arr) => {

    if (arr.length !== 0 && (basic_OkrDetails.users.owners.filter(owner => owner.id === parseInt(arr[arr.length - 1].value)).length || basic_OkrDetails.users.owners.filter(owner => arr.some(user => user.value == owner.id)).length)) {
      setIsRestrictParticipantUpdate(true);
      setIsErorParticipant(true);
      return false;
    }
    else {
      setIsErorParticipant(false);
      setIsRestrictParticipantUpdate(false);
      setParticipants_toEdit(arr);
      setParticipants_toEditErrMsg(false);
    }
    setIsErorParticipant(false);

  }


  const handleParticipantsUpdate = () => {
    setIsRestrictParticipantUpdate(true);
    let participants_toEditIds;
    if (participants_toEdit.length === 0) {
      setParticipants_toEditErrMsg(true);
      return false;
    }
    if (participants_toEdit.length !== 0) {

      participants_toEditIds = participants_toEdit.map(participants => participants.value).toString();
    }

    var close = document.getElementById("closebtn");
    close.click();


    axiosFetch({
      method: "post",
      url: "/data/update",
      requestConfig: {
        "itemId": id,
        "tableName": "OkrObjects",
        "fieldName": "ParticipantIds",
        "typeId": 2,
        "value": participants_toEdit.length !== 0 ? participants_toEditIds : null
      }
    })

      .then((res) => {
        if (res.status === 200) {
          if (res.data === 'success') {
            dispatch(SnackbarActions(true, "success", "Updated Successfully"));
            loadBasicOKRDetails();
          }
        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })

  };

  const loadBasicOKRDetails = () => {

    setIsLoading(true);
    if (id !== null) {
      axiosFetch({
        method: "get",
        url: `/OKRs/okr/basic/${id}`
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.okrDetail !== null) {
              setIsLoading(false);
              setBasic_OkrDetails(res.data.okrDetail);
              setCreatedBy(res.data.okrDetail.createdby);
              setIsArchive(res.data.okrDetail.isArchived);
              setPageData(res.data.pageData);
              setIsPrivate(res.data.okrDetail.isPrivate);
              setIsPublished(res.data.okrDetail.isPublished);

              if (res.data.okrDetail.dueDate !== null) {
                var date = res.data.okrDetail.dueDate;
                var splitedDate = date.split("T");
                setDueDate_toEdit(splitedDate[0]);
              }
              // setIsPublished()
            }
          }
          else if (res.status === 400) {
            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
          }
          else if (res.status === 401) {
            navigate('/');
          }
        })
        .catch(err => console.error(err));
    }

  }


  const loadKeyResults = () => {
    setIsLoadingKeyResult(true);
    axiosFetch({
      method: "post",
      url: `/OKRs/okr/keyresults`,
      requestConfig: {
        "page": page,
        "resultsPerPage": 10,
        "totalRecords": 10,
        "objectiveId": id
      }
    })
      .then((res) => {

        if (res.status === 200) {
          setIsLoadingKeyResult(false);
          keyResults.push(res.data.items);

          if (page > 1) {
            var results = [...keyResultsList.items, ...res.data.items];

            setKeyResultsList({ items: results });

          }
          else {
            setKeyResultsList(res.data);
          }
          setTotalPages(res.data.pagination.totalPages);
          setTotalRecords(res.data.pagination.totalRecords - res.data.items.filter(item => item.isArchived === true).length);
        }
        else if (res.status === 204) {
          setIsLoadingKeyResult(false);
          setTotalRecords(0);
          setKeyResultsList(res.data);
          setIsContentAvailable(true);
        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
      .catch(err => console.error(err));

  }

  const loadComments = () => {

    axiosFetch({
      method: "get",
      url: `/OKRs/okr/comments/${id}`
    })
      .then((res) => {
        if (res.status === 200) {
          setComments(res.data);
        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
      .catch(err => console.error(err));

  }

  const deleteAttachment = (file, type) => {

    console.log(file)
    axiosFetch({
      method: "post",
      url: `/OKRs/okr/update/attachment`,
      requestConfig: {
        "id": file.attachmentId,
        "isFileOrUrl": type === 0 ? true : false,
        "value": type === 0 ? file.physicalName : file.url
      }
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(SnackbarActions(true, "success", "Deleted Successfully!"));
          loadBasicOKRDetails();

        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
  }
  const archiveTheOkr = () => {
    setIsArchive(!isArchive);
    axiosFetch({
      method: "post",
      url: "/OKRs/okr/archive",
      requestConfig: {
        "objectId": id,
        "assignmentTypeId": 1,
        "isArchived": !isArchive
      }

    })
      .then((res) => {
        if (res.status === 200) {
          isArchive ? dispatch(SnackbarActions(true, "success", "OKR UnArchived!")) : dispatch(SnackbarActions(true, "success", "OKR Archived!"));
          setOpenDialog(false);
          if (!isPublished) {
            navigate('/myokrs');
          }

          setTimeout(() => {
            loadBasicOKRDetails();
          }, 3000)
        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate("/");
        }
      })

      .catch(err => console.error(err));
  }



  const handlePageChange = (val) => {

    setPage(val);
  }
  const handleInfiniteOnLoad = () => {

    if (page + 1 <= totalPages) {
      setPage(page + 1);
    }
  }
  const toggleOkrPopup = (param, obj) => {

    if (param !== undefined && param !== "1") {
      setIsPopupOpen(false);
    } else if (param === undefined) {
      setIsAssignKR(false);
      setIsPopupOpen(true);
    } else if (param === "1") {
      setSelectedOkrId(obj);
      setIsPopupOpen(true);
      setIsAssignKR(true);
    }
  };

  const handleChangeList = () => {

    keyResults = [];
  }

  const handleTitleChange = (e) => {
    setTitle_toEditErrMsg(false);
    setTitle_toEdit(e.target.value);
  }

  const handleChangeDescription = (e) => {

    setDescription_toEdit(e.target.value);
    setDesciption_toEditErrMsg(false);
  }

  const navigateToParentOKR = () => {
    navigate(`/viewokr/${basic_OkrDetails.parentId}`);
    navigate(0);
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px dotted pink',
      color: state.isSelected ? 'red' : 'blue',
      padding: 20,
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      width: 200,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };

    }
  }

  const keyResultsUserList = () => {
    axiosFetch({
      url: `/Lookup/users/${id}`,
      method: "get"
    })
      .then((res) => {
        if (res.status === 200) {
          setKRUserList(res.data);
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })

      .catch(err => console.log(err));
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {closeConfirmPopup ? (
          <IconButton
            aria-label="close"
            onClick={closeConfirmPopup}
            sx={{
              position: "absolute",
              right: 0,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };



  const closeConfirmPopup = () => {
    setOpenDialog(false);
  };


  const openConfirmPopup = () => {
    if (!isArchive) {
      if (!isPublished) {
        setOpenDialog(true);
        setAnchorEl(null);
      }
      else {
        setOpenDialog(true);
        setAnchorEl(null);
      }
    }
    else {
      setOpenDialog(true);
      setAnchorEl(null);
    }
  };


  useEffect(() => {
    // window.scrollTo(0, 0);
    loadBasicOKRDetails();
    loadComments();
    dispatch(loadUsers())
    dispatch(loadStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {

    // window.scrollTo(0, 0);
    loadKeyResults();
    keyResultsUserList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);


  return (



    <div className="argus-view-okr">
      <Dialog
        open={openDialog}
        onClose={closeConfirmPopup}
        aria-describedby="alert-dialog-slide-description"
        className="small-info-popup"
        fullWidth="sm"
        maxWidth="sm"
      >
        <BootstrapDialogTitle className="modal-heading">
          Archiving OKR
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="error">{!isPublished ? "Archiving the draft item will be deleted permanently. Are you sure you want to continue?" : isArchive ? "Are you sure you want to UnArchive?" : "Are you sure you want to Archive?"}</Alert></Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmPopup} className="no-btn theme-btn cancel-btn">No</Button>
          <Button onClick={archiveTheOkr} className="yes-btn theme-btn">Yes</Button>

        </DialogActions>
      </Dialog>

      {
        isOpen_CommentsPopup ? (
          <AddNewCommentsPopup
            open={true}
            commentId={commentId}
            toggleCommentsPopup={toggleCommentsPopup}
            loadComments={loadComments}
            loadKeyResults={loadKeyResults}
            handlePageChange={handlePageChange}
            callFrom={0}
            pageNo={page}

          />
        )
          : ""
      }

      {isPopupOpen ? (
        <AddNewOkr
          open={true}
          toggleOkrPopup={toggleOkrPopup}
          isAssignKR={isAssignKR}
          selectedOkrId={selectedOkrId}
          loadKeyResults={loadKeyResults}
          handleChangeList={handleChangeList}
          handlePageChange={handlePageChange}
          objectiveTitle={basic_OkrDetails !== null ? basic_OkrDetails.title : null}
          // 1 indicates sending props from ViewOKR
          callFrom={1}
        />
      ) : ("")}
      {/* <Grid container> */}

      {isLoading ? <StencilList length={1} Component={ViewOKR} data={ViewOKRDummyData} /> : <Box>
        {/* <Paper elevation={3}> */}
        <Grid container>
          <Grid item xs={12}>
            <div className="argus-okr-box">
              <Grid container>
                <Grid lg={7}>
                  <h3 className="stensil view-okr-heading">{basic_OkrDetails !== null && basic_OkrDetails.title !== undefined ? `(#${basic_OkrDetails.id})` + " " + basic_OkrDetails.title : (<span className="stensil-ignore">-</span>)}</h3>
                  {(isArchive || basic_OkrDetails !== null && basic_OkrDetails.parentId !== undefined && basic_OkrDetails.parentId !== null) ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (
                    <PopupState variant="popper" className="stensil-ignore okr-edit-button" popupId="demo-popup-popper">
                      {(popupState) => (
                        <div className="okr-edit" style={{ display: "inline-block" }}>
                          <IconButton
                            aria-label="edit"
                            size="small"
                            {...bindToggle(popupState)}
                            className="stensil-ignore"
                          >
                            <ModeEdit color="secondary" fontSize="inherit" />
                          </IconButton>
                          <Popover {...bindPopover(popupState)} transition className="edit-popup">
                            <Paper>
                              <TextField
                                id="filled-basic"
                                placeholder="Objective Title"
                                variant="outlined"
                                // value={title_toEdit}
                                defaultValue={basic_OkrDetails !== null && basic_OkrDetails.title !== undefined ? basic_OkrDetails.title : ""}
                                onChange={handleTitleChange}
                                multiline
                                fullWidth
                                rows={5}
                              />
                              <p className="error-message">{title_toEditErrMsg ? "Please enter valid title" : ""}</p>
                              <IconButton color="success" 
                              disabled={title_toEdit!==""?false:true}
                              >
                                <CheckCircleOutlineOutlined
                                  onClick={handleTitleUpdate}
                                />
                              </IconButton>
                              <IconButton
                                id="closebtn"
                                sx={{ color: "red" }}
                                {...bindToggle(popupState)}
                              >
                                <CancelOutlined />
                              </IconButton>
                            </Paper>

                          </Popover>
                        </div>
                      )}
                    </PopupState>
                  ) : (
                    ""
                  )}

                  {basic_OkrDetails !== null && basic_OkrDetails.parentId !== null ?
                    <p className="custom-alert"><InsertLinkIcon /> Linked from Key result of Objective &nbsp;<Link onClick={navigateToParentOKR} className="stensil-ignore"> {`(#${basic_OkrDetails.parentId})` + " " + basic_OkrDetails.parentTitle}</Link></p> : ""}
                </Grid>

                {userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.parentId === null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0)
                  ? <Grid lg={5}>
                    <Button variant="contained" className="stensil-ignore theme-btn danger-btn" style={{ marginLeft: "10px" }} onClick={openConfirmPopup}>
                      {isArchive ? 'UnArchive' : 'Archive'}
                    </Button>
                    {isArchive ? "" : <Button variant="contained" className="stensil-ignore theme-btn" onClick={toggleDraft}>{basic_OkrDetails !== null && basic_OkrDetails.isPublished ? "Save As Draft" : "Remove from Draft"}</Button>}
                    {isPrivate ? <Button variant="contained" className="stensil-ignore theme-btn" onClick={publishOKR} style={{ marginRight: "11px" }}>Make it Public</Button> : ""}
                  </Grid> : ""}
              </Grid>
              <br />
              {/* <FormControlLabel
                control={
                  <Switch
                    name="isDraft"
                    color="primary"
                    checked={isPublished}
                    onChange={toggleDraft}
                  />
                }
                label="Include Draft OKRs"
                className='stensil-ignore toggle-btn'
              /> */}
              <h5 className="stensil-ignore okr-description" style={{ display: "inline-block", margin: "0" }}>Description : {basic_OkrDetails !== null && basic_OkrDetails.description !== undefined && basic_OkrDetails.description !== null ? basic_OkrDetails.description : (<span className="stensil-ignore">-</span>)}</h5>
              {(isArchive || basic_OkrDetails !== null && basic_OkrDetails.parentId !== undefined && basic_OkrDetails.parentId !== null) ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (
                <PopupState variant="popper" className="stensil-ignore okr-edit-button" popupId="demo-popup-popper">
                  {(popupState) => (
                    <div className="okr-edit" style={{ display: "inline-block" }}>
                      <IconButton
                        aria-label="edit"
                        size="small"
                        {...bindToggle(popupState)}
                        className="stensil-ignore"
                      >
                        <ModeEdit color="secondary" fontSize="inherit" />
                      </IconButton>
                      <Popover {...bindPopover(popupState)} transition className="edit-popup description-custom-popup">
                        <Paper>
                          <TextareaAutosize
                            placeholder="Description"
                            aria-label="empty textarea"
                            className="desc-okr"
                            defaultValue={basic_OkrDetails !== null && basic_OkrDetails.description !== undefined ? basic_OkrDetails.description : ""}
                            onChange={handleChangeDescription}
                            style={{ width: 200 }}
                          />
                          <p className="error-message">{description_toEditErrMsg ? "Please enter valid description" : ""}</p>
                          <IconButton color="success"
                              disabled={description_toEdit!==""?false:true}                          
                          >
                            <CheckCircleOutlineOutlined
                              onClick={handleDescriptionUpdate}
                            />
                          </IconButton>
                          <IconButton
                            id="closebtn"
                            sx={{ color: "red" }}
                            {...bindToggle(popupState)}
                          >
                            <CancelOutlined />
                          </IconButton>
                        </Paper>

                      </Popover>
                    </div>
                  )}
                </PopupState>
              ) : (
                ""
              )}
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <span className="okr-span">
                    <strong className="stensil okr-label">Status : </strong>&nbsp;
                    {basic_OkrDetails !== null && basic_OkrDetails.description !== undefined ? basic_OkrDetails.statusName : <span className="stensil-ignore">-</span>}
                    {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (
                      <PopupState variant="popper" className="stensil-ignore okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                              className="stensil-ignore"
                            >
                              <ModeEdit color="secondary" fontSize="inherit" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup">

                              <Paper>
                                <Select
                                  placeholder="Select Status"
                                  name="Status"
                                  style={customStyles}
                                  // value={selectedStatus}
                                  defaultValue={basic_OkrDetails !== null && basic_OkrDetails.statusId !== undefined ? statusList.filter(status => status.value === basic_OkrDetails.statusId) : ""}
                                  options={statusList}
                                  onChange={handleChangeStatus}
                                />
                                <br />
                                <p>{isErrorStatus ? "Please select valid option" : ""}</p>
                                <IconButton
                                  color="success"
                                  onClick={handleStatusUpdate}
                                  disabled={isErrorStatus}
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                    ) : (
                      ""
                    )}
                  </span>
                  <span className="okr-span">
                    <strong className="stensil okr-label">Due Date : </strong>&nbsp;
                    {basic_OkrDetails !== null && basic_OkrDetails.dueDate !== undefined && basic_OkrDetails.dueDate !== null ? moment(basic_OkrDetails.dueDate).format('MMM-DD-YYYY') : (<span className="stensil-ignore">-</span>)}
                    {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (
                      <PopupState variant="popper" className="stensil-ignore okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                              className="stensil-ignore"
                            >
                              <ModeEdit color="secondary" fontSize="inherit" className="stensil-ignore" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup">

                              <Paper>
                                <DatePicker
                                  // minDate={moment().toDate()}
                                  placeholderText="Due Date"
                                  value={dueDate_toEdit}
                                  fullWidth
                                  className="datetime"
                                  dateFormat="yyyy-MM-dd"
                                  selected={new Date(dueDate_toEdit)}
                                  onSelect={(date) => {
                                    handleChangeDueDate(date)
                                  }}
                                />
                                {/* <TextField
                                  id="filled-basic"
                                  variant="filled"
                                  type="date"
                                  value={dueDate_toEdit}
                                  onChange={handleChangeDueDate}
                                /> */}
                                <p className="error-message">{dueDate_toEditErrMsg ? "Please enter valid date" : ""}</p>
                                <IconButton
                                  onClick={handleDueDateUpdate}
                                  color="success"
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                    ) : (
                      ""
                    )}
                  </span>
                  <span className="okr-span participants-span">
                    <strong className="stensil okr-label">Owner's Name :  </strong>&nbsp;
                    {basic_OkrDetails !== null
                      && basic_OkrDetails.users !== []
                      && basic_OkrDetails.users.owners.length !== 0 ? basic_OkrDetails.users.owners.map((owner, index) => (
                        <>&nbsp;<a className="ownername" href={`/users-profile/${owner.id}`}>{owner.firstName + " " + owner.lastName}{index + 1 !== basic_OkrDetails.users.owners.length ? "," : ""}</a></>)) : (<span className="stensil-ignore">-</span>)}
                    {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (
                      <PopupState variant="popper" className="stensil-ignore okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                              className="stensil-ignore"
                            >
                              <ModeEdit color="secondary" fontSize="inherit" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup">

                              <Paper>
                                <Select
                                  placeholder="Select Owners"
                                  name="Owners"
                                  // value={owner_toEdit}
                                  defaultValue={basic_OkrDetails !== null
                                    && basic_OkrDetails.users.length !== 0
                                    && basic_OkrDetails.users.owners.length !== 0 ?
                                    usersList.filter(user => {
                                      return basic_OkrDetails.users.owners.some(owner => {
                                        return user.value === owner.id.toString()
                                      })
                                    }) : ""}
                                  options={usersList}
                                  onChange={handleChangeOwner_toEdit}
                                  isMulti={true}
                                />
                                <p className="error-message">{owner_toEditErrMsg ? "Please select any" : ""}</p>
                                <p className="error-message">{isErrorOwner ? "Owner & Participant can't be same person" : ""}</p>
                                <IconButton
                                  disabled={isRestrictOwnerUpdate}
                                  color="success"
                                  onClick={handleOwnerUpdate}
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                    ) : (
                      ""
                    )}
                  </span>
                  <span className="okr-span participants-span">
                    <strong className="stensil okr-label">Participant's Name:  </strong> &nbsp;
                    {basic_OkrDetails !== null
                      && basic_OkrDetails.users.length !== 0
                      && basic_OkrDetails.users.participants.length !== 0 ?
                      basic_OkrDetails.users.participants.map((participant, index) => (<a className="ownername" href={`/users-profile/${participant.id}`}>{participant.firstName + " " + participant.lastName}{index + 1 !== basic_OkrDetails.users.participants.length ? "," : ""}</a>)) : (<span className="stensil-ignore">-</span>)}
                    {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (
                      <PopupState variant="popper" className="stensil-ignore okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                              className="stensil-ignore"
                            >
                              <ModeEdit color="secondary" fontSize="inherit" className="stensil-ignore" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup">

                              <Paper>
                                <Select
                                  placeholder="Select Participants"
                                  name="Participants"
                                  // value={participants_toEdit}
                                  defaultValue={basic_OkrDetails !== null
                                    && basic_OkrDetails.users.length !== 0
                                    && basic_OkrDetails.users.participants.length !== 0 ?
                                    usersList.filter(user => {
                                      return basic_OkrDetails.users.participants.some(participant => {
                                        return user.value === participant.id.toString()
                                      })
                                    }) : []}
                                  options={usersList}
                                  onChange={handleChangeParticipants}
                                  isMulti={true}
                                />
                                <p className="error-message">{isErrorParticipant ? "Owner & Participant can't be same person" : ""}</p>
                                <p className="error-message">{participants_toEditErrMsg ? "Please Select any" : ""}</p>
                                <IconButton
                                  color="success"
                                  onClick={handleParticipantsUpdate}
                                  disabled={isRestrictParticipantUpdate}
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                    ) : (
                      ""
                    )}
                  </span>
                  <span className="stensil-ignore"><strong>Attachments :</strong> <br />
                    <div className="attachment">{basic_OkrDetails && basic_OkrDetails.attachments !== null && basic_OkrDetails.attachments.length !== 0 ? basic_OkrDetails.attachments.map((file, index) => (<>{file.actualFileName !== null ? (<span className="attach">{file.typeName !== null ? <p>File Type : {file.typeName}</p> : ''}<a className="ownername" href={`/api/uploads/file/download/${file.physicalName}`}><InsertDriveFileIcon className="icon" /> <strong>{file.actualFileName}</strong></a>{isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? <Button className="delete-btn" onClick={() => deleteAttachment(file, 0)}><DeleteIcon className="icon" /></Button> : ""}</span>) : ""}{file.url !== null ? <span className="attach"> <a href={`${file.url}`} target="_blank"><AttachFileIcon className="icon" />{`${file.url !== null && file.actualFileName !== null ? ":" + file.url : file.url}`}</a>  {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? <Button className="delete-btn" onClick={() => deleteAttachment(file, 1)}><DeleteIcon className="icon" /></Button> : ""}</span> : (index + 1) !== basic_OkrDetails.attachments.length ? "" : ""}</>)) : ("")}</div>
                    {/* {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (<FileUpload className="icon" okrId={id} loadOKR={loadBasicOKRDetails} />) : ""} */}
                  </span>
                  <span className="upload-btn">
                    {isArchive ? "" : userType === "Admin" || (userid === createdby) || (basic_OkrDetails !== null && basic_OkrDetails.users.owners.length !== 0 && basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0) || (basic_OkrDetails !== null && basic_OkrDetails.users.participants.length !== 0 && basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? (<FileUpload className="icon" okrId={id} loadOKR={loadBasicOKRDetails} />) : ""}
                  </span>
                </Grid>
                {basic_OkrDetails && basic_OkrDetails.completionPercentage !== null ? <Grid item xs={3}>
                  <div className="argus-okr-box">
                    {/* <Grid item xs={4}> */}

                    {/* </Grid> */}
                    <Grid container spacing={2} sx={{ padding: "0" }}>
                      <Grid item xs={12}>
                        {/* <BorderLinearProgress 
                    value={basic_OkrDetails !== null && basic_OkrDetails.completionPercentage !== undefined && basic_OkrDetails.completionPercentage !== null ? basic_OkrDetails.completionPercentage : ""}
                  /> */}
                        <h4 className="stensil-ignore okr-percentage">{basic_OkrDetails !== null && basic_OkrDetails.completionPercentage !== undefined && basic_OkrDetails.completionPercentage !== null ? Math.round(basic_OkrDetails.completionPercentage * 100) / 100 + "%" : "0%"}</h4>
                      </Grid>
                      {/* </Grid> */}

                      {/* <Grid item xs={2}>
                  <h6 className="okr-progress">{basic_OkrDetails !== null && basic_OkrDetails.completionPercentage !== undefined && basic_OkrDetails.completionPercentage !== null ? basic_OkrDetails.completionPercentage + "%" : ""}</h6>
                  
                </Grid> */}
                    </Grid>

                  </div>
                </Grid>
                  : ""}
                {/* <Grid item xs={7} sx={{ textAlign: "center" }}>
                  
                </Grid> */}
              </Grid>
            </div>
          </Grid>
          {/* </Grid> */}
        </Grid>
        {/* </Paper> */}
      </Box >}
      {/* </Grid> */}

      <Grid container spacing={2} >
        <Box sx={{ marginTop: 2 }} className="argus-org-tab">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                className="kr-tabs training-tab "
                value={tabValue}
                onChange={handleChange}
                aria-label="basic tabs example"
              >

                <Tab className="one-tab"
                  {...a11yProps(0)}
                  label={
                    <Badge badgeContent={totalRecords !== null ? totalRecords.toString() : "0"} color="primary">
                      Key Results
                    </Badge>
                  }
                />
                <Tab className="sec-tab" {...a11yProps(1)} label={<Badge className="kr-count " badgeContent={comments.length !== 0 ? comments.length : "0"} color="primary">Comments</Badge>} />
                {/* <Tab label="Audit Log" {...a11yProps(2)} /> */}

              </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
              {isLoadingKeyResult ? <StencilList
                length={1}
                Component={KeyResults}
                data={dummyData}
              /> : (
                <InfiniteScroll
                  initialLoad={false}
                  loadMore={handleInfiniteOnLoad}
                  hasMore={page !== totalPages}
                  threshold={20}>
                  <KeyResults

                    {...keyResultsList}
                    krUserList={krUserList}
                    isContentAvailable={isContentAvailable}
                    keyResults={keyResults}
                    loadKeyResults={loadKeyResults}
                    loadBasicOKRDetails={loadBasicOKRDetails}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    toggleCommentsPopup={toggleCommentsPopup}
                    toggleOkrPopup={toggleOkrPopup}
                    handlePageChange={handlePageChange}
                    pageNo={page}
                    basic_OkrDetails={basic_OkrDetails}
                    isLoading={isLoadingKeyResult}

                  />
                </InfiniteScroll>

              )}


            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <Comments
                loadComments={loadComments}
                comments={comments}
                toggleCommentsPopup={toggleCommentsPopup}
                handleChangeList={handleChangeList}
                okrId={id}
                isContentAvailable={isContentAvailable}
                basic_OkrDetails={basic_OkrDetails}
              />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <AuditLog toggleCommentsPopup={toggleCommentsPopup} okrId={id} />
            </TabPanel>

          </Box>
          {/* </Paper> */}
          {/* </Paper> */}
        </Box>
      </Grid >
      <CustomizedSnackbar />
    </div >

  );
};

export default ViewOKR;
